import React from 'react';
import { CityFringeDashboard } from './components/CityFringeDashboard';
export function App() {
  return <CityFringeDashboard data-id="element-0" />;
}